export enum openPostViewerEventSources {
  AnglerProfile = 'a-p',
  BrandsGrid = 'br-gr',
  FishingWaterHeaderImage = 'fw-hi',
  FishingWaterRecentCatchImage = 'fw-rci',
  FishingReportRecentCatch = 'fr-rc',
  FishingReportPopularCatch = 'fr-pc',
  SpeciesHeaderImage = 'spc-hi',
  SpeciesRecentCatchImage = 'spc-rci',
  TripOtherCatchesFromUserImage = 'trp-ocui',
  TripOtherCatchesFromTripImage = 'trp-octi',
  PlaceTrophyCatchesImage = 'plc-tci',
  PlaceRecentCatchesImage = 'plc-rci',
  FishingReport = 'fr',
  PagesCatches = 'pg-c',
}
